// App.js
import { Routes, Route } from 'react-router-dom';
import { Suspense, lazy } from 'react';
import Header from './components/Header';
import PrivateRoute from './auth/PrivateRoute';
import RoleRoute from './auth/RoleRoute';

// 🔻 lazy-load every page component (each file must have a default export)
const LoginPage     = lazy(() => import('./pages/LoginPage'));
const SignupPage    = lazy(() => import('./pages/SignupPage'));
const Dashboard     = lazy(() => import('./pages/Dashboard'));
const VerifyEmail   = lazy(() => import('./pages/VerifyEmail'));
const Verified      = lazy(() => import('./pages/Verified'));
const SubscribePage = lazy(() => import('./pages/SubscribePage'));
const BillingSuccess = lazy(() => import('./pages/BillingSuccess'));
const HomePage      = lazy(() => import('./pages/HomePage'));
const ResetPassword = lazy(() => import('./pages/ResetPassword'));
const CartsPage = lazy(() => import('./pages/Carts'));
const VinSearch     = lazy(() => import('./pages/VinSearch'));
const AdminFinance = lazy(() => import('./pages/admin/Finance'));
const ManagerFinance = lazy(() => import('./pages/manager/Finance'));
// NEW admin subpages
const AdminLayout        = lazy(() => import('./pages/admin/AdminLayout'));
const AdminPrices        = lazy(() => import('./pages/admin/Prices'));
const AdminCatalytics    = lazy(() => import('./pages/admin/Catalytics'));
const AdminSubscriptions = lazy(() => import('./pages/admin/Subscriptions'));
const UserStats = lazy(() => import('./pages/admin/UserStats'));
const AdminAlerts = lazy(() => import('./pages/admin/AdminAlerts'));
const NotificationsPage = lazy(() => import('./pages/Notifications'));
const ManagerCatalytics = lazy(() => import('./pages/manager/Catalytics'));
const ManagerPrices = lazy(() => import('./pages/manager/Prices'));

// (optional) a tiny fallback while chunks load
function RouteFallback() {
  return <div style={{ padding: 24 }}>Loading…</div>;
}

export default function App() {
  return (
    <>
      <Header />
      <div className="container">
        {/* 🔻 Suspense handles the lazy chunks */}
        <Suspense fallback={<RouteFallback />}>
          <Routes>
            <Route path="/" element={<PrivateRoute><HomePage /></PrivateRoute>} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/signup" element={<SignupPage />} />
            <Route path="/reset-password" element={<ResetPassword />} /> 
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/verified" element={<Verified />} />
            <Route path="/subscribe" element={<SubscribePage />} />
            <Route path="/billing/success" element={<BillingSuccess />} />
            <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
            <Route path="/carts" element={<PrivateRoute><CartsPage /></PrivateRoute>} />
            <Route path="/vin" element={<PrivateRoute><VinSearch /></PrivateRoute>} />
            <Route path="/notifications" element={<PrivateRoute><NotificationsPage /></PrivateRoute>} />

               {/* Admin (nested) — admin-only */}
               <Route
                 path="/admin"
                 element={
                   <RoleRoute allow={['admin']}>
                     <AdminLayout />
                   </RoleRoute>
                 }
               >
              <Route index element={<AdminPrices />} />
              <Route path="prices" element={<AdminPrices />} />
              <Route path="catalytics" element={<AdminCatalytics />} />
              <Route path="subscriptions" element={<AdminSubscriptions />} />
              <Route path="finance" element={<AdminFinance />} />
              <Route path="/admin/user-stats" element={<UserStats />} />
              <Route path="alerts" element={<AdminAlerts />} />
            </Route>

              {/* Manager finance page: separate top-level route (no admin nesting) */}
              <Route
                path="/manager/finance"
                element={
                  <RoleRoute allow={['manager']}>
                  <ManagerFinance />
                  </RoleRoute>
                }
              />
              
              <Route
                path="/manager/catalytics"
                element={
                  <RoleRoute allow={['manager']}>
                    <ManagerCatalytics />
                  </RoleRoute>
                }
              />

              <Route
                path="/manager/prices"
                element={
                  <RoleRoute allow={['manager']}>
                    <ManagerPrices />
                  </RoleRoute>
                }
              />
          </Routes>
        </Suspense>
      </div>
    </>
  );
}
